import { useEffect } from 'react'

/**
 * Sets `document.title` to "<part> · <part> · VONK" while the page is mounted
 * (empty parts are skipped) and puts the previous title back on unmount.
 */
export function useDocumentTitle(parts: readonly (string | null | undefined)[]): void {
  // A string key keeps the effect stable for callers that pass a fresh array each render.
  const title = [...parts.filter((part): part is string => Boolean(part)), 'VONK'].join(' · ')
  useEffect(() => {
    const previous = document.title
    document.title = title
    return () => {
      document.title = previous
    }
  }, [title])
}
